import React, { useContext, useState, useEffect } from 'react';
import avatar from "../assets/avatar.svg";
import { FaHome, FaRegEnvelope, FaPhoneAlt, FaUserEdit, FaLock } from "react-icons/fa";
import { FiUser } from "react-icons/fi";
import { Card, Dropdown, Button, Modal, InputGroup, FormControl } from 'react-bootstrap';
import { HomePage, HomeContent, Profile } from "../styles";
import Menu from "../components/Menu";
import { UserContext } from "../context/UserContext";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';
import { UserService } from '../services/user-service';

function useFormik({
    initialValues,
    validate
  }) {
    const [touched, setTouchedFields] = useState({});
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState(initialValues);
  
    useEffect(() => {
      validateValues(values);
    }, [values]);
  
    function handleChange(event) {
      const fieldName = event.target.getAttribute('name');
      const { value } = event.target;
      setValues({
        ...values,
        [fieldName]: value,
      });
    }
  
    function handleBlur(event) {
      const fieldName = event.target.getAttribute('name');
      setTouchedFields({
        ...touched,
        [fieldName]: true,
      })
    }
  
    function validateValues(values) {
      setErrors(validate(values));
    }
  
    return {
      values,
      errors,
      touched,
      handleBlur,
      setErrors,
      handleChange,
    };
}


function Perfil(props) {
  const [error, setError] = useState(null);
  const [user, setUser] = useContext(UserContext);
  const [passwordModal, setPasswordModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confNewPassword: '',
    },
    validate: function (values) {
      const errors = {};
    
      if(values.newPassword.length < 4) {
        errors.newPassword = '* Deve conter mais de 3 dígitos'
      }
    
      if(values.confNewPassword.length < 4) {
        errors.confNewPassword = '* Deve conter mais de 3 dígitos'
      }
    
      return errors;
    }
  });

  function onLocationChange(item) {
    setUser({
        ...user,
        location_name: item.commercial_name,
        location_id: item.location_id,
        selected: item
    });
    localStorage.setItem('location_data', JSON.stringify(item));
  }

  let dropdownItems = user.locations.map((item, index)=>{
    return(
      <Dropdown.Item active={item.location_id === user.location_id ? true : false} key={item.location_id} onSelect={()=> onLocationChange(item)}>{item.commercial_name}</Dropdown.Item>
    )
  });

  function closeModal() {
    setPasswordModal(false);
  }

  function changePass(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const data = formik.values;
    if(data.newPassword === data.confNewPassword) {
      const password = { password: data.newPassword };
      UserService.change_password(user.token, password).then(() => {
        setLoading(false);
      }, (error)=> {
        setLoading(false);
        setError('Ocorreu um erro.');
      });
    } else {
      setLoading(false);
      setError('As Passwords não coicidem.');
    }
  }

  return (
      <HomePage>
        <Menu locations={true} page="perfil" />
        <HomeContent>
          <div className="pageTitle"><FiUser/>Meu Perfil</div>  
          <Profile>
            <Card className="w-100 mb-3"> 
              <Card.Header>Meus Dados</Card.Header>
              <Card.Body>
                <h3>{user.name}</h3>
                <small className="text-muted">{user.email}</small><br />
                <Button
                  variant="danger"
                  size="sm" 
                  onClick={()=> setPasswordModal(true)}
                ><FaUserEdit/> Alterar a Password</Button>
              </Card.Body>
            </Card>
            {user.locations.length > 0 ? 
              <Dropdown>
                <Dropdown.Toggle variant="danger" size="sm">
                  {user.location_name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {dropdownItems}
                </Dropdown.Menu>  
              </Dropdown>
               
            : null} 
            <Card className="mt-4 w-100"> 
              <Card.Header>Dados Local</Card.Header>  
              <Card.Body className="text-left">
                <div className="text-center"> 
                { user.selected?.logo ?
                  <img className="logo" src={user.selected.logo} alt="Logo" />:
                  <img src={avatar} alt="Avatar" />
                }
                <h4 className="mt-2">{user.location_name} </h4>
                </div>
                <hr/>
                <small>
                  {user.selected?.email ? 
                    <div>
                      <FaRegEnvelope /> {user.selected?.email}<br />
                    </div> : null
                  }

                  {user.selected?.telephone1 ? 
                    <div>
                      <FaPhoneAlt /> {user.selected?.telephone1}<br />
                    </div> : null
                  }

                  {user.selected?.address ? 
                    <div>
                      <FaHome /> {user.selected?.address}
                    </div> : null
                  }
                  <hr />
                  <p className="text-muted" dangerouslySetInnerHTML={{ __html: user.selected?.description }}></p>
                </small>
              </Card.Body>
            </Card>

            <Modal show={passwordModal} onHide={closeModal}>
              <Modal.Header closeButton>
                <Modal.Title>Alterar a Password</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form>
                  <div className="mb-3">
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text id="basic-addon1"><FaLock /></InputGroup.Text>
                      </InputGroup.Prepend>
                      <FormControl
                        placeholder="Nova Password"
                        name="newPassword"
                        id="newPassword"
                        type="password"
                        onBlur={formik.handleBlur} 
                        onChange={formik.handleChange} 
                        value={formik.values.newPassword}
                      />
                    </InputGroup>
                    {formik.touched.newPassword && formik.errors.newPassword && <span className="error">{formik.errors.newPassword}</span>}
                  </div>

                  <div className="mb-3">
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text id="basic-addon1"><FaLock /></InputGroup.Text>
                      </InputGroup.Prepend>
                      <FormControl
                        placeholder="Confirma Nova Password"
                        name="confNewPassword"
                        id="confNewPassword"
                        type="password"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.confNewPassword}
                      />
                    </InputGroup>
                    {formik.touched.confNewPassword && formik.errors.confNewPassword && <span className="error">{formik.errors.confNewPassword}</span>}
                  </div>
                  {error && <span className="error">{error}</span>}
                </form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                  Fechar
                </Button>
                {loading ?
                  <Loader
                    type="ThreeDots"
                    color="#28a745"
                    height={40}
                    width={40}
                  /> :
                  <Button 
                    variant="success"
                    onClick={changePass}
                    disabled={(formik.errors.newPassword || formik.errors.confNewPassword)}
                  >
                    Confirmar
                  </Button>}
              </Modal.Footer>
            </Modal>
          </Profile>
        </HomeContent>
      </HomePage>
  );
}

export default Perfil;

